import { t } from 'i18next'

import type { TTipoDoVinculoDoCompradorEnum } from '@/types/proposta'

export const getTipoCompradorKeyMap = (): Record<'Comprador' | TTipoDoVinculoDoCompradorEnum, string> => ({
  Comprador: t('enums:tipo_comprador.comprador'),
  MaePai: t('enums:tipo_comprador.mae_pai'),
  Conjuge: t('enums:tipo_comprador.conjuge'),
  Representante: t('enums:tipo_comprador.representante'),
  Procurador: t('enums:tipo_comprador.procurador'),
})
